import { ButtonProps, Button } from "@/components/Button";
import {
  Input as HeadlessInput,
  InputProps as HeadlessInputProps,
} from "@headlessui/react";
import React, { ComponentProps, FC } from "react";

type ButtonInput = Extract<ButtonProps, ComponentProps<"button">> & {
  type: "button" | "reset" | "submit";
};

type FileInput = {
  type: "file";
} & HeadlessInputProps;

export type ButtonInputProps = ButtonInput | FileInput;
/**
 * DO NOT USE!
 * USE THE FACADE COMPONENT `Input` or `Button` INSTEAD.
 */
export const ButtonInput: FC<ButtonInputProps> = (props) => {
  switch (props.type) {
    case "file": {
      /**
       * Not styled yet
       */
      return <HeadlessInput {...props} />;
    }
    case "button":
    case "reset":
    case "submit":
      return <Button as="input" {...props} type={props.type} />;
  }
};
